<template>
    <textarea :id="id"></textarea>
</template>

<script setup>
import { onMounted, ref, defineProps, defineExpose } from 'vue';

const props = defineProps({
    content: String,
    id: String
});

const id = `tinymce_${props.id}`;

const editorInstance = ref(null);

onMounted(() => {
    window.tinymce.remove(`#${id}`);
    window.tinymce.init({
        selector: `#${id}`,
        menubar: false,
        statusbar: false,
        plugins: 'code link', 
        toolbar: 
            'undo redo | bold italic backcolor forecolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist | removeformat | link | code',
        // Configuración para el modal de agregar link
        link_target_list: false,
        link_default_target: '_blank',
        link_title: false,
        link_assume_external_targets: true,
        link_class_list: [{title: 'tiny', value: 'tinymce-link'}],
        setup: (editor) => {
            editorInstance.value = editor;
            editor.on('init', () => {
                editor.setContent(props.content);
            });
        },
    });
})

defineExpose({
  editorInstance
});
</script>

<style lang="scss"> //NO agregar "scoped"
.tox-dialog{
    *{
        font-family: 'Open Sans', sans-serif !important; 
    }
    &__title{
        font-size: 16px !important;
        font-weight: 700 !important;
    }
    &__body-content{
        padding-bottom: 0 !important;
    }
    &__footer{
        padding-bottom: 12px !important;
    }
    .tox-label{
        color: #000 !important;
        padding: 4px 0 !important;
    }
    input{
        font-size: 14px !important;
        &:focus{
            box-shadow: none !important;
            border-color: #eee !important;
        }
    }
}
.tox-button{
    background: #009696 !important;
    border: none !important;
    font-family: Arial, Helvetica, sans-serif !important;
    border-radius: 20px !important;
    font-weight: 600 !important;
    &::before{
        box-shadow: none !important;
    }
    &--secondary{
        background: none !important;
        color: #009696 !important;
    }
    &--icon{
        background: none !important;
    }
}

//Ocultar select de clases al crear link
.tox-listboxfield {
    display: none !important;
}
</style>
